import { render, staticRenderFns } from "./PageServe.vue?vue&type=template&id=ed3fa224&scoped=true&"
import script from "./PageServe.vue?vue&type=script&lang=js&"
export * from "./PageServe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3fa224",
  null
  
)

export default component.exports